import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BookingModal from '../../components/feature/BookingModal';
import { SEO } from '../../utils/seo';

export default function MidsizeCarPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [galleryType, setGalleryType] = useState<'exterior' | 'interior'>('exterior');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const vehicles = [
    {
      id: 1,
      name: '현대 쏘나타 디엣지 비지니스1',
      price: '100,000',
      fuel: 'LPG(25년식)',
      seats: '5인승',
      transmission: '자동(스마트키, 통풍시트, 2채널블박)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/7ca22c8fdea4436e553d01216d6b014b.png',
      exteriorImages: [
        'https://public.readdy.ai/ai/img_res/c10063ae384a8e36d5354a33343bb2f8.jpg',
        'https://readdy.ai/api/search-image?query=Hyundai%20Sonata%20The%20Edge%20sedan%20exterior%20side%20profile%20view%20in%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20sleek%20silhouette%20and%20dynamic%20proportions&width=1200&height=800&seq=midsize-sonata-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Sonata%20The%20Edge%20sedan%20exterior%20rear%20three-quarter%20view%20in%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20modern%20tail%20lamp%20design%20and%20refined%20rear%20styling&width=1200&height=800&seq=midsize-sonata-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Sonata%20The%20Edge%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20modern%20black%20leather%20upholstery%2C%20large%20touchscreen%20display%2C%20digital%20instrument%20cluster%2C%20premium%20materials%2C%20ventilated%20seats%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-sonata-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Sonata%20The%20Edge%20sedan%20interior%20center%20console%20and%20gear%20shifter%20close-up%20view%20with%20premium%20black%20materials%2C%20modern%20control%20interfaces%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-sonata-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Sonata%20The%20Edge%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20comfort%20and%20luxury&width=1200&height=800&seq=midsize-sonata-int-3&orientation=landscape',
      ],
    },
    {
      id: 2,
      name: '기아 K5 트렌디',
      price: '80,000',
      fuel: 'LPG(22년식)',
      seats: '5인승',
      transmission: '자동(스마트키, 통풍시트, 2채널블박)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/eb041f66fb498e4e826a628964f01909.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20K5%20midsize%20sedan%20exterior%20front%20three-quarter%20view%20in%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20sophisticated%20design%20and%20sporty%20character&width=1200&height=800&seq=midsize-k5-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K5%20midsize%20sedan%20exterior%20side%20profile%20view%20in%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20dynamic%20fastback%20silhouette%20and%20athletic%20stance&width=1200&height=800&seq=midsize-k5-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K5%20midsize%20sedan%20exterior%20rear%20three-quarter%20view%20in%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20LED%20tail%20lamps%20and%20sporty%20rear%20design&width=1200&height=800&seq=midsize-k5-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20K5%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20modern%20black%20leather%20upholstery%2C%20dual%20widescreen%20displays%2C%20digital%20cockpit%2C%20premium%20materials%2C%20ventilated%20seats%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-k5-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K5%20sedan%20interior%20center%20console%20and%20gear%20shifter%20close-up%20view%20with%20premium%20black%20materials%2C%20modern%20push-button%20gear%20selector%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-k5-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K5%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20generous%20legroom%20and%20comfort&width=1200&height=800&seq=midsize-k5-int-3&orientation=landscape',
      ],
    },
    {
      id: 3,
      name: '현대 그랜저GN7 프리미엄',
      price: '180,000',
      fuel: '가솔린(24년식)',
      seats: '5인승',
      transmission: '자동(스마트키, 통풍시트, 2채널블박)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/a20b400c85ac6d6a2a9d660001425ad3.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Grandeur%20GN7%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20dark%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20premium%20design%20and%20executive%20presence&width=1200&height=800&seq=midsize-grandeur-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Grandeur%20GN7%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20dark%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20elegant%20proportions%20and%20refined%20silhouette&width=1200&height=800&seq=midsize-grandeur-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Grandeur%20GN7%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20dark%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20sophisticated%20rear%20design%20and%20premium%20character&width=1200&height=800&seq=midsize-grandeur-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Grandeur%20GN7%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20beige%20leather%20upholstery%2C%20dual%20curved%20displays%2C%20digital%20cockpit%2C%20premium%20wood%20trim%2C%20ventilated%20seats%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-grandeur-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Grandeur%20GN7%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20crystal%20gear%20knob%2C%20ambient%20lighting%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-grandeur-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Grandeur%20GN7%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20beige%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20first-class%20comfort%20and%20luxury&width=1200&height=800&seq=midsize-grandeur-int-3&orientation=landscape',
      ],
    },
    {
      id: 4,
      name: '기아 K8 노블레스',
      price: '180,000',
      fuel: '가솔린(24년식)',
      seats: '5인승',
      transmission: '자동(스마트키, 통풍시트, 2채널블박)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/e7162a639132a8a402708db1ceaaa679.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20K8%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20bold%20design%20and%20premium%20presence&width=1200&height=800&seq=midsize-k8-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K8%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20long%20wheelbase%20and%20elegant%20proportions&width=1200&height=800&seq=midsize-k8-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K8%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20LED%20tail%20lamps%20and%20sophisticated%20rear%20styling&width=1200&height=800&seq=midsize-k8-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20K8%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20black%20Nappa%20leather%20upholstery%2C%20panoramic%20curved%20display%2C%20digital%20cockpit%2C%20premium%20materials%2C%20ventilated%20seats%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-k8-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K8%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20black%20materials%2C%20electronic%20gear%20selector%2C%20ambient%20lighting%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-k8-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20K8%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20Nappa%20leather%20seating%2C%20premium%20relaxation%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20executive-class%20comfort&width=1200&height=800&seq=midsize-k8-int-3&orientation=landscape',
      ],
    },
    {
      id: 5,
      name: '현대 쏘나타 디엣지 인스퍼레이션',
      price: '100,000',
      fuel: '가솔린(25년식)',
      seats: '5인승',
      transmission: '자동(스마트키,HUD, 2채널블박,풀옵션)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/7ca22c8fdea4436e553d01216d6b014b.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Genesis%20G70%20luxury%20sports%20sedan%20exterior%20front%20three-quarter%20view%20in%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20athletic%20design%20and%20premium%20Korean%20luxury%20character&width=1200&height=800&seq=midsize-g70-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G70%20luxury%20sports%20sedan%20exterior%20side%20profile%20view%20in%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20sporty%20silhouette%20and%20dynamic%20proportions&width=1200&height=800&seq=midsize-g70-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G70%20luxury%20sports%20sedan%20exterior%20rear%20three-quarter%20view%20in%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20quad%20exhaust%20and%20sporty%20rear%20design&width=1200&height=800&seq=midsize-g70-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Genesis%20G70%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20premium%20black%20leather%20sport%20seats%2C%20modern%20infotainment%20display%2C%20digital%20instrument%20cluster%2C%20luxury%20materials%2C%20ventilated%20seats%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-g70-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G70%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20sport%20gear%20selector%2C%20Genesis%20luxury%20details%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-g70-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G70%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20premium%20black%20leather%20seating%2C%20luxury%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20refined%20luxury%20and%20comfort&width=1200&height=800&seq=midsize-g70-int-3&orientation=landscape',
      ],
    },
    {
      id: 6,
      name: '쉐보레 말리부',
      price: '130,000',
      fuel: '가솔린',
      seats: '5인승',
      transmission: '자동(스마트키, 통풍시트, 2채널블박)',
      image: 'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20midsize%20sedan%20in%20sophisticated%20gray%20color%20on%20clean%20minimalist%20gradient%20background%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20professional%20automotive%20photography%20with%20studio%20lighting%2C%20American%20midsize%20sedan%20design%2C%20side%20three-quarter%20view%20emphasizing%20comfortable%20styling%20and%20spacious%20interior&width=500&height=350&seq=midsize-malibu-001&orientation=landscape',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20midsize%20sedan%20exterior%20front%20three-quarter%20view%20in%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20American%20sedan%20design%20and%20sophisticated%20styling&width=1200&height=800&seq=midsize-malibu-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20midsize%20sedan%20exterior%20side%20profile%20view%20in%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20elegant%20proportions%20and%20comfortable%20character&width=1200&height=800&seq=midsize-malibu-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20midsize%20sedan%20exterior%20rear%20three-quarter%20view%20in%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20modern%20tail%20lamp%20design%20and%20refined%20rear%20styling&width=1200&height=800&seq=midsize-malibu-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20comfortable%20black%20cloth%20upholstery%2C%20touchscreen%20infotainment%20system%2C%20modern%20instrument%20cluster%2C%20quality%20materials%2C%20ventilated%20seats%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-malibu-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20sedan%20interior%20center%20console%20close-up%20view%20with%20modern%20materials%2C%20electronic%20gear%20selector%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=midsize-malibu-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Chevrolet%20Malibu%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20seating%2C%20comfortable%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20generous%20space%20and%20comfort&width=1200&height=800&seq=midsize-malibu-int-3&orientation=landscape',
      ],
    },
  ];

  const openGallery = (vehicle: any, type: 'exterior' | 'interior') => {
    setSelectedVehicle(vehicle);
    setGalleryType(type);
    setCurrentImageIndex(0);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedVehicle(null);
  };

  const getCurrentImages = () => {
    if (!selectedVehicle) return [];
    return galleryType === 'exterior' ? selectedVehicle.exteriorImages : selectedVehicle.interiorImages;
  };

  const nextImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "대전중형차렌트카",
        "description": "넓은 실내 공간과 안정적인 주행감을 자랑하는 중형차로 편안한 여행을 즐기세요. 비즈니스 출장이나 가족 여행에 최적화된 차량입니다.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/midsize-car`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "대전렌트카",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        }
      },
      {
        "@type": "ItemList",
        "name": "대전 중형차 렌트 차량 목록",
        "description": "대전렌트카 중형차 렌트 차량 목록",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/midsize-car`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "현대 쏘나타 디엣지 비지니스1",
            "description": "LPG 25년식 중형 세단, 1일 렌트 ₩100,000"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "기아 K5 트렌디",
            "description": "LPG 22년식 중형 세단, 1일 렌트 ₩80,000"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "현대 그랜저GN7 프리미엄",
            "description": "가솔린 24년식 준대형 세단, 1일 렌트 ₩180,000"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "기아 K8 노블레스",
            "description": "가솔린 24년식 준대형 세단, 1일 렌트 ₩180,000"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "현대 쏘나타 디엣지 인스퍼레이션",
            "description": "가솔린 25년식 풀옵션 중형 세단, 1일 렌트 ₩100,000"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "쉐보레 말리부",
            "description": "가솔린 중형 세단, 1일 렌트 ₩130,000"
          }
        ]
      }
    ]
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <SEO
          title="대전중형차렌트카 - 편안한 중형차 렌트 | 대전렌트카"
          description="넓은 실내 공간과 안정적인 주행감을 자랑하는 중형차로 편안한 여행을 즐기세요. 비즈니스 출장이나 가족 여행에 최적화된 차량입니다. 24시간 예약 가능."
          keywords="대전중형차렌트카, 대전중형차대여, 중형세단렌트, 비즈니스렌트카, 가족여행렌트카"
          canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/midsize-car`}
          schema={schema}
        />
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="mb-12">
              <div className="flex items-center justify-between mb-4">
                <h1 className="text-5xl font-bold text-gray-900">대전중형차렌트카</h1>
                <a 
                  href="tel:010-5437-1535"
                  className="flex items-center gap-3 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-semibold">010-5437-1535</span>
                </a>
              </div>
              <p className="text-lg text-gray-600">
                넓은 실내 공간과 안정적인 주행감을 자랑하는 중형차로 편안한 여행을 즐기세요. 
                비즈니스 출장이나 가족 여행에 최적화된 차량입니다.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-64 bg-gradient-to-b from-sky-50 to-white p-6">
                    <img
                      src={vehicle.image}
                      alt={vehicle.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{vehicle.name}</h3>
                    <p className="text-3xl font-extrabold text-primary mb-1">₩{vehicle.price}</p>
                    <p className="text-sm text-gray-500 mb-4">자차별도</p>
                    <div className="grid grid-cols-2 gap-3 mb-6 text-sm text-gray-600">
                      <div className="flex items-center gap-2">
                        <i className="ri-gas-station-line text-primary"></i>
                        <span>{vehicle.fuel}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-user-line text-primary"></i>
                        <span>{vehicle.seats}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-settings-3-line text-primary"></i>
                        <span>{vehicle.transmission}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-calendar-line text-primary"></i>
                        <span>1일 기준</span>
                      </div>
                    </div>

                    {/* 이미지 갤러리 버튼 */}
                    <div className="flex gap-2 mb-4">
                      <button
                        onClick={() => openGallery(vehicle, 'exterior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-image-line mr-1"></i>
                        외부사진
                      </button>
                      <button
                        onClick={() => openGallery(vehicle, 'interior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-steering-2-line mr-1"></i>
                        내부사진
                      </button>
                    </div>

                    <a 
                      href="tel:010-5437-1535"
                      className="w-full bg-gray-900 text-white py-3 rounded-xl font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap block text-center"
                    >
                      지금 예약하기
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
        <Footer />
        <BookingModal 
          isOpen={isBookingModalOpen} 
          onClose={() => setIsBookingModalOpen(false)} 
        />

        {/* 이미지 갤러리 모달 */}
        {isGalleryOpen && selectedVehicle && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-4xl"></i>
            </button>

            <div className="w-full max-w-6xl">
              {/* 탭 */}
              <div className="flex justify-center gap-4 mb-6">
                <button
                  onClick={() => { setGalleryType('exterior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'exterior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  외부사진
                </button>
                <button
                  onClick={() => { setGalleryType('interior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'interior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  내부사진
                </button>
              </div>

              {/* 메인 이미지 */}
              <div className="relative aspect-video bg-black rounded-lg overflow-hidden mb-4">
                <img
                  src={getCurrentImages()[currentImageIndex]}
                  alt={`${selectedVehicle.name} ${galleryType === 'exterior' ? '외부' : '내부'} ${currentImageIndex + 1}`}
                  className="w-full h-full object-contain"
                />
                
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </div>

              {/* 썸네일 */}
              <div className="flex justify-center gap-2">
                {getCurrentImages().map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentImageIndex(idx)}
                    className={`w-20 h-20 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                      idx === currentImageIndex ? 'border-primary' : 'border-transparent opacity-50 hover:opacity-100'
                    }`}
                  >
                    <img src={img} alt={`썸네일 ${idx + 1}`} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}